module.exports = __webpack_public_path__ + "static/02-ae066c245b399f5a47ae0e6729e3b8f9.jpg";